import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import React from 'react';
import { ImageCropEditorProps } from '@/components/ImageCropEditor/useImageCropEditorProps';

const ImageCropEditor = ({
  previewImage: src,
  minHeight,
  minWidth,
  ...editorProps
}: ImageCropEditorProps) => {
  return (
    <ReactCrop
      {...editorProps}
      // 세로가 긴 이미지는 캔버스보다 좁게 그려지므로, 테두리와 자르기 영역을 이미지 크기에 맞춘다.
      style={{
        border: '3px solid #000',
        width: 'fit-content',
        margin: '0 auto',
      }}
    >
      {src && <img alt={'크롭할 이미지'} src={src} />}
    </ReactCrop>
  );
};

export default ImageCropEditor;
